import React, { useMemo } from "react";
import { X } from "lucide-react";
import AuditHistory from "../../components/AuditHistory";

const FIELD_LABELS = { approval_team_uuid: "Approval Team" };

export default function JobApprovalTeamHistoryModal({
  job,
  approvalTeams,
  onClose,
}) {
  const teamNameByUuid = useMemo(() => {
    const map = {};
    (approvalTeams || []).forEach((team) => {
      map[team.uuid] = team.name;
    });
    return map;
  }, [approvalTeams]);

  const valueFormatters = useMemo(
    () => ({
      approval_team_uuid: (uuid) =>
        uuid ? teamNameByUuid[uuid] || uuid : null,
    }),
    [teamNameByUuid]
  );

  if (!job) return null;

  return (
    <div className="jfm-overlay" onClick={onClose}>
      <div
        className="jfm-container audit-history-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="jfm-header">
          <span className="jfm-title">
            History — {job.code} {job.description}
          </span>
          <button className="jfm-close" onClick={onClose}>
            <X size={18} />
          </button>
        </div>

        <div className="jfm-body">
          <AuditHistory
            resource="job_approval_teams"
            service="identity"
            uuid={job.uuid}
            createdAt={job.created_at}
            fieldLabels={FIELD_LABELS}
            valueFormatters={valueFormatters}
          />
        </div>
      </div>
    </div>
  );
}
